import { useEffect, useRef } from "react";

// mogelijks hier een async loader plaatsen, om er voor te zorgen dat Google-API zeker volledig geladen is voor gebruik

const GoogleMap = () => {
  const mapRef = useRef(null);

  useEffect(() => {
    const loadGoogleMaps = () => {
      if (window.google) {
        const { Map } = window.google.maps;
        const { AdvancedMarkerElement } = window.google.maps.marker;
        
        const position = { lat: 51.22229, lng: 3.260197 };

        const map = new Map(mapRef.current, {
          center: position,
          zoom: 16,
          mapId: "DEMO_MAP_ID",
        });

        new AdvancedMarkerElement({
          map,
          position,
          title: "My location",
        });
      }
    };

    if (!window.google) {
      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyAGPcqVmeXpz4H1FSCyck6Y5EL94jF9zy4&libraries=maps,marker`;
      script.async = true;
      script.defer = true;
      script.onload = loadGoogleMaps;
      document.head.appendChild(script);
    } else {
      loadGoogleMaps();
    }
  }, []);

  return <div ref={mapRef} style={{ width: "80%",
    height: "500px",
    borderRadius: "10px",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
    border: "1px solid #ccc", }} />;
};

export default GoogleMap;